import { render, staticRenderFns } from "./Callout.vue?vue&type=template&id=a60e9762&scoped=true&"
import script from "./Callout.vue?vue&type=script&lang=ts&"
export * from "./Callout.vue?vue&type=script&lang=ts&"
import style0 from "./Callout.vue?vue&type=style&index=0&id=a60e9762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60e9762",
  null
  
)

export default component.exports